import {SxType} from "@baseTypes/sx/sxTypes";
import {
    DATE_LAST_62_DAYS_START_END,
    DATE_LAST_START_END,
    DATE_MONTH_START_END,
    DATE_PREVIOUS_MONTH_START_END,
    DATE_QUARTER_DAY_START_END,
    DATE_START_END_TODAY,
    DATE_WEEK_START_END,
    DATE_YEAR_START_END
} from "@ui/datePicker/constants";

interface IChipPalette {
    text: string,
    soft: string,
    softDark: string,
    textDark: string,
}

const ACTIVE_COLOR = 'var(--account-accent, #0C6DDF)'

const PALETTE_DAY: IChipPalette = {text: 'var(--account-accent-text, #1E63B5)', soft: 'var(--account-accent-soft, #EEF5FD)', softDark: 'var(--account-accent-soft, rgba(12, 109, 223, 0.12))', textDark: 'var(--account-accent-light, #9CC3F2)'}
const PALETTE_WEEK: IChipPalette = {text: 'var(--account-accent-text, #1A579F)', soft: 'var(--account-accent-soft, #DFEBFA)', softDark: 'var(--account-accent-soft, rgba(12, 109, 223, 0.2))', textDark: 'var(--account-accent-light, #A9CBF4)'}
const PALETTE_MONTH: IChipPalette = {text: 'var(--account-accent-text, #154A88)', soft: 'var(--account-accent-tint, #CDE0F7)', softDark: 'var(--account-accent-tint, rgba(12, 109, 223, 0.28))', textDark: 'var(--account-accent-light, #B7D3F6)'}
const PALETTE_LONG: IChipPalette = {text: 'var(--account-accent-text, #103C70)', soft: 'var(--account-accent-tint, #B9D3F3)', softDark: 'var(--account-accent-tint, rgba(12, 109, 223, 0.36))', textDark: 'var(--account-accent-light, #C6DCF8)'}
const PALETTE_DEFAULT: IChipPalette = PALETTE_DAY

const PALETTE_BY_KEY: Record<string, IChipPalette> = {
    [DATE_START_END_TODAY]: PALETTE_DAY,
    [DATE_LAST_START_END]: PALETTE_DAY,
    [DATE_WEEK_START_END]: PALETTE_WEEK,
    [DATE_MONTH_START_END]: PALETTE_MONTH,
    [DATE_PREVIOUS_MONTH_START_END]: PALETTE_MONTH,
    [DATE_LAST_62_DAYS_START_END]: PALETTE_LONG,
    [DATE_QUARTER_DAY_START_END]: PALETTE_DEFAULT,
    [DATE_YEAR_START_END]: PALETTE_DEFAULT,
}

export const sxGrid: SxType = {
    display: 'grid',
    gridTemplateColumns: 'repeat(2, minmax(0, 1fr))',
    gap: '4px',
    width: '100%',
}

export const getChipSxDateStartEndTemplate = (key: string, active: boolean): SxType => {
    const palette = PALETTE_BY_KEY[key] ?? PALETTE_DEFAULT

    return {
        width: '100%',
        height: '24px',
        borderRadius: '6px',
        '& .MuiChip-label': {
            width: '100%',
            paddingLeft: '4px',
            paddingRight: '4px',
            textAlign: 'center',
            overflow: 'hidden',
            textOverflow: 'ellipsis',
        },
        fontWeight: 600,
        fontSize: '12px',
        border: '1px solid',
        transition: 'all .2s',
        '.lightTheme &': {
            color: active ? '#fff' : palette.text,
            backgroundColor: active ? ACTIVE_COLOR : palette.soft,
            borderColor: active ? ACTIVE_COLOR : 'transparent',
            '&:hover': {
                backgroundColor: active ? ACTIVE_COLOR : palette.soft,
                borderColor: ACTIVE_COLOR,
            },
        },
        '.darkTheme &': {
            color: active ? '#fff' : palette.textDark,
            backgroundColor: active ? ACTIVE_COLOR : palette.softDark,
            borderColor: active ? ACTIVE_COLOR : 'transparent',
            '&:hover': {
                backgroundColor: active ? ACTIVE_COLOR : palette.softDark,
                borderColor: palette.textDark,
            },
        },
    }
}
